import { i18n } from '@/i18n'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('app.presentations_aeat'),
      // name: i18n.t('app.notifications'),
      path: 'notification/presentations',
      use_parent_params: true,
      params_required: ['id', 'type'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          // name: i18n.t('app.new_notification'),
          path: 'presentation/new',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        // {
        //   name: i18n.t('app.tags_link'),
        //   path: 'redirect',
        //   disabled: true,
        //   registerNavFromMenu: false,
        //   sc: [] // shorcuts
        // },
        // {
        //   name: i18n.t('app.historical'),
        //   path: 'redirect',
        //   disabled: true,
        //   registerNavFromMenu: false,
        //   sc: [] // shorcuts
        // }
      ]
    }
  ]
}
